import { useMemo, useState } from 'react';
import AnalyzeScoreWrite2 from './AnalyzeScoreWrite2';
import AnalyzeReportWrite from './AnalyzeReportWrite';
import AnalyzeTotalResult from './AnalyzeTotalResult';
import { useGlobalStore } from '../../../components/contexts';

const AnalyzeDetailContent = ({
  svcObj,
  detailRef,
  onChangeDetailRef,
  modalService,
}) => {
  const { store, updateStore } = useGlobalStore();
  const isReadOnly = useMemo(() => {
    return store.authrtId !== 'EX' || svcObj.status === 'EXPRT05';
  }, [store, svcObj]);

  // 작업별 공통 tab menu 기능 구현
  const [currentTab, clickTab] = useState(0);
  let modalParam = { svcObj, detailRef, isAnalyze: true };

  const tabMenuArr = [
    {
      id: 'ATR',
      name: 'AI 분석 총괄표',
      content: (
        <AnalyzeTotalResult
          param={{
            anlsAplyId: svcObj.aiaAplyId,
            entSn: svcObj.entSn,
            vdoId: detailRef.vdoId,
          }}
        />
      ),
    },
    {
      id: 'ASW',
      name: '전문가 점수',
      content: (
        <AnalyzeScoreWrite2
          detailRef={detailRef}
          onChangeDetailRef={onChangeDetailRef}
          isReadOnly={isReadOnly}
        />
      ),
    },
    {
      id: 'ARW',
      name: '전문가 보고서',
      content: (
        <AnalyzeReportWrite
          id={detailRef.exprtAnlsDtlId}
          detailRef={detailRef}
          onChangeDetailRef={onChangeDetailRef}
          isReadOnly={isReadOnly}
        />
      ),
    },
  ];

  const selectTabMenuHandler = index => {
    clickTab(index);
  };

  const setButtonTextByAuth = () => {
    let buttonText = '';
    // userId = 전문가
    if (store.authrtId === 'EX') {
      // 분석, 추가자료요청 단계
      if (svcObj.status === 'EXPRT03' || svcObj.status === 'EXPRT04') {
        buttonText = '추가자료 요청';
      } else {
        buttonText = '추가자료 확인';
      }
    }
    // userId = 기업 사용자
    else {
      // 추가자료요청 단계
      if (svcObj.status === 'EXPRT04') {
        buttonText = '추가자료 제출';
      } else {
        buttonText = '추가자료 확인';
      }
    }
    modalParam = { ...modalParam, buttonText };

    return buttonText;
  };

  return (
    <>
      <div className="section">
        <div className="tabs-wrap">
          <ul className="nav-tabs">
            {tabMenuArr.map((el, index) =>
              (el.id === 'ASW' || el.id === 'ARW') &&
              store.authrtId !== 'EX' &&
              svcObj.status !== 'EXPRT05' ? null : (
                <li
                  key={index}
                  className={index === currentTab ? 'tabs on' : 'tabs'}
                  onClick={() => selectTabMenuHandler(index)}
                >
                  <a>{el.name}</a>
                </li>
              )
            )}
          </ul>
        </div>
        <div className="result-box-wrap">{tabMenuArr[currentTab].content}</div>
        {svcObj.status === 'EXPRT01' || svcObj.status === 'EXPRT02' ? (
          <div></div>
        ) : (
          <div className="btn-group2">
            <button
              type="button"
              className="btn btn--sml"
              onClick={() => {
                // 추가자료 요청 Modal
                modalService.openModal(
                  'AnalyzeAddModal',
                  modalParam,
                  (index, isCompleted) => {
                    // Callback
                    onChangeDetailRef(index, 'addCmptnYn', isCompleted);
                  }
                );
              }}
            >
              {setButtonTextByAuth()}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default AnalyzeDetailContent;
